export const animateNormal = (bar1, bar2) => {
  let color = "aqua";

  bar1.style.backgroundColor = color;
  if (bar2 !== null)  bar2.style.backgroundColor = color; 
}